import React,{useState} from 'react';
import { Bar } from 'react-chartjs-2';
import { Box,Card} from '@material-ui/core'
import moment from 'moment';

const arrMes=["Ene","Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov" , "Dic"]
const GraficaDirect = ({lista,leyenda, opcion}) => {
    const [arrCampos, setArrCampos] = useState([]) 
    const [arrTitulo, setArrTitulo] = useState([]) 
    const DATA_COUNT = 12;
    const labels = [];
    for (let i = 0; i < DATA_COUNT; ++i) {
    labels.push(i.toString());
    }
    //const datapoints = [0, 20, 20, 60, 60, 120, NaN, 180, 120, 125, 105, 110, 170];
    const colores=["#5DE163","#FFC400","#24392D","#018786","#03DAC5",]
    const camposListas=[
        'Temperatura Ambiente', 'Valor Referencia de Velocidad del Sistema',
        'Temperatura de Rodamiento del Motor ','Temperatura Inverter LeitDrive 1',
        'Temperatura Inverter LeitDrive 2',        
        ]
    React.useEffect(()=>{                 
       // console.log(lista);
        let auxArreglo= [ ], auxTitulo=[];        
        let contador=0;

        lista.forEach((lectura) =>
        { //const mes=moment(lectura.Mes).format("MMM MMMM")                     
            auxArreglo[contador] =lectura.Uso   
            auxTitulo[contador] = opcion ===1 ? `${lectura.Anio} ${arrMes[lectura.Mes]} `:`${lectura.Dia} ${arrMes[lectura.Mes]}`   
            contador++                                                                  
        })             
        //console.log(auxArreglo);
                  
        setArrCampos(auxArreglo)
        setArrTitulo(auxTitulo)
   
    },[lista,]);

    const generaData=()=>
    {   let arreData=[]
        
        arreData.push(
        {   type: 'line',
            label:leyenda,
            data: arrCampos,
            backgroundColor: "#5DE163",
            borderColor: "#5DE163",
            fill: false                             
            ,tension: 0.4
        })
        
       // console.log(arreData);
        return(arreData)
    }

    const data = {
        labels:arrTitulo,
        /* datasets: [
            {type: 'line',
            label: camposListas[0],
            data: arrGrafica1[0],
            backgroundColor: colores[0],
            fill: false,
            cubicInterpolationMode: 'monotone',
            tension: 0.4
            }, 
            {type: 'line',
            label: camposListas[1],
            data: arrGrafica1[1],
            backgroundColor: colores[1],
            fill: false,
            tension: 0.4
            }
        ] */
        datasets:generaData()
    };

    const config = {
    type: 'line',
    data: data,
    options: {
        responsive: true,
        plugins: {
        title: {
            display: true,
            text: 'Chart.js Line Chart - Cubic interpolation mode'
        },
        },
        interaction: {
        intersect: false,
        },
        scales: {
        x: {
            display: true,
            title: {
            display: true
            }
        },
        y: {
            display: true,
            title: {
            display: true,
            text: 'Value'
            },
            suggestedMin: -10,
            suggestedMax: 200
        }
        }
    },
    };

    const options={

        responsive: true,
        plugins: {
          title: {
            display: false,
            text: 'Días'
          },
        },
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: opcion===1?"Meses":'Dias'
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: 'Horas'
            },
            min: 0,
            //suggestedMin: -10,
           // suggestedMax: 200
          }
          
        },
        legend: {
            display: false,
          },
          tooltips: {
            enabled: true,
          },
      /* onClick: (e) => {
            console.log(e);
            
        } */
    }

    return (
    <Box  pt={1}        >                    
      <Bar data={data} 
        options={options}
        width={800}
        height={280}
        
      />
    </Box>  
    );
}
 
export default GraficaDirect;